import Vue from 'vue'
import { unref } from '@vue/composition-api'
import customPush from 'custom-push'
import parsePushData from 'custom-push/pushParser/parsePushData'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'

// 订阅/取消订阅 outcome
export const subOutcomePush = ({ sportId, categoryId, tournamentId, eventId, marketIds = [] }, callback = null, isSub = true) => {
  // 订阅参数
  const pushOption = {
    type: 3,
    sportId,
    categoryId,
    tournamentId,
    eventId,
    marketIds
  }
  customPush.pushTopic(pushOption, callback, isSub)
}

const updateOutcome = (outcomes, newOutcome) => {
  const { id } = newOutcome
  const index = outcomes.findIndex((x) => x.id === id)
  if (index !== -1) {
    const currentOutcome = outcomes[index]
    Object.assign(currentOutcome, newOutcome)
    Vue.set(outcomes, index, currentOutcome)
  } else {
    // 新增 outcome
    outcomes.push(newOutcome)
  }
}

const getSpecifiers = (topicInfo) => {
  let specifiers = topicInfo.marketSpecifiers
  if (specifiers) {
    // topic中不能出现 |所以specifier多个的情况用&连接，现在在改回去
    specifiers = specifiers.split('&').join('|')
  }
  return specifiers
}

// 更新 outcome 信息
export const generateUpdateOutcomes =
  ({ marketMap, getPushTime, updateMarket, updatePushTime }) =>
  (data) => {
    const pushData = JSON.parse(data)
    const outcomesInfo = parsePushData(pushData, 'odds')
    // console.log('push odds:', outcomesInfo)
    // 修正 odds 推送中的 market priority 位置
    const marketPushData = [...pushData]
    marketPushData[9] = marketPushData[10]
    let { pushTime } = parsePushData(marketPushData, 'market')
    if (updateMarket) {
      updateMarket(marketPushData)
    }
    pushTime = Number(pushTime)
    if (!outcomesInfo) return

    // 网络延迟可能导致后收到的数据不是最新的
    const lastPushTime = getPushTime()
    if (lastPushTime && lastPushTime.value > pushTime) return

    const topicInfo = parseTopicInfo(pushData[0], 'market')
    const { marketId } = topicInfo
    let targetMarket = unref(marketMap)[marketId]
    if (!targetMarket) return

    const specifiers = getSpecifiers(topicInfo)

    if (specifiers) {
      // specifiers market array
      targetMarket = targetMarket.find((x) => x.specifiers === specifiers)
    }
    if (!targetMarket) return

    const outcomes = targetMarket.outcomes
    if (!outcomes) {
      targetMarket.outcomes = []
    }
    Object.entries(outcomesInfo).forEach(([id, outcome]) => {
      updateOutcome(targetMarket.outcomes, { id, ...outcome })
    })

    updatePushTime(pushTime)
  }
